module.exports = __webpack_public_path__ + "files/19e918d45ba1b1b10d28e89410cb444b.png";